module.exports = __webpack_public_path__ + "img/Enrique-Suarez.329ad783.jpg";